import { useMemo, useRef, useCallback } from 'react';

import { CHART_COLORS } from '@gogame/components';

import { BREAK_DOWN_COLORS } from 'scenes/Trackers/components/colors';

import { useIsBreakdownMode } from './useChartIsBreakdownMode';

export const useColorGetter = (series) => {
  const breakDownMode = useIsBreakdownMode();
  const uniqColorKeysRef = useRef([]);
  const getColorByIndex = useCallback(
    (index) => {
      const colors = breakDownMode ? BREAK_DOWN_COLORS : CHART_COLORS;
      return colors[index % colors.length];
    },
    [breakDownMode]
  );

  useMemo(() => {
    uniqColorKeysRef.current = [];
  }, [series, getColorByIndex]);

  return (colorKey) => {
    if (!uniqColorKeysRef.current.includes(colorKey)) {
      uniqColorKeysRef.current = [...uniqColorKeysRef.current, colorKey];
      return getColorByIndex(uniqColorKeysRef.current.length - 1);
    }
    return getColorByIndex(uniqColorKeysRef.current.indexOf(colorKey));
  };
};
